import React from 'react';
import cx from 'classnames';
import { Accordion, Button } from 'library';

import CMSContent from '../../common/CMSContent/CMSContent';

import './FAQList.scss';

const FAQList = ({ data }) => {
  const { heading, faqs, includeSectionTitle, sectionTitle, showFaqsPageLink } = data.block.blockFields.faqListBlock[0];

  return (
    <div
      className={cx('FAQContainer', {
        isTiempos: includeSectionTitle && !heading,
      })}
    >
      {(heading || sectionTitle) && <h1 className="FAQHeading">{heading || sectionTitle}</h1>}
      {faqs.map(({ faqGroup }) => (
        <Accordion header={faqGroup.question} key={faqGroup.question}>
          <CMSContent content={faqGroup.answer} />
        </Accordion>
      ))}
      {showFaqsPageLink && (
        <Button href="/faqs" theme="outlined" style={{ marginTop: '50px' }}>
          View All FAQs
        </Button>
      )}
    </div>
  );
};

export default FAQList;
